exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cca-etl-chat-app {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n}\n\n.cca-etl-chat-app {\n    height: 100%;\n    background: cadetblue;\n    padding: 8px;\n    border-radius: 4px;\n    font-family: Helvetica, sans-serif;\n    font-weight: 300;\n    display: flex;\n    flex-direction: column;\n}\n\n.cca-etl-chat-app * {\n    box-sizing: border-box;\n}", ""]);

// exports
